export { default } from './SmartFilterSummary';
